import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import AuthLayout from "./app/layouts/AuthLayout";
import AppLayout from "./app/layouts/AppLayout";
import routes from "./app/routes/routes";
import "./App.css";
import ProtectedRoute from "./app/routes/protectedRoutes";
import Toast from "./app/components/Toast/Toast";

const renderRoutes = (routesToRender) => {
  return routesToRender
    .filter((route) => route.layout === "app" || !route.layout)
    .map((route) => (
      <Route
        key={route.path}
        path={route.path}
        element={
          route.roles ? (
            <ProtectedRoute roles={route.roles}>{route.element}</ProtectedRoute>
          ) : (
            route.element
          )
        }
      >
        {route.children && renderRoutes(route.children)}
      </Route>
    ));
};

function App() {
  return (
    <Router>
      <Routes>
        {/* Auth Routes */}
        <Route element={<AuthLayout />}>
          {routes
            .filter((route) => route.layout === "auth")
            .map((route) => (
              <Route
                key={route.path}
                path={route.path}
                element={route.element}
              />
            ))}
        </Route>

        {/* app Routes */}
        <Route element={<ProtectedRoute />}>
          <Route element={<AppLayout />}>
            <Route path="/" element={<Navigate to="/credentials" replace />} />
            {renderRoutes(routes)}
          </Route>
        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
      <Toast />
    </Router>
  );
}

export default App;
